import * as React from "react";
import { Container } from "react-bootstrap";
import Seo from "../components/Seo";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";

import { newsPageTplData } from "../data/page-tpl-news.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import PageHead from "../components/Page/PageHead";
import Articles from "../components/Articles";
import Hero from "../componentsSections/Hero";

const pageResources = ({ pageContext }) => {
    const { id, currentPage, totalPages, skip, limit, archivePath } =
        pageContext;
    const seoPageData = getCurrentPageSeo(id);
    const pageData = newsPageTplData(id);
    const canonicalPath = archivePath
        ? currentPage === 1
            ? archivePath
            : `${archivePath}page/${currentPage}/`
        : undefined;

    return (
        <Layout pageTitle={seoPageData.title}>
            <Seo post={seoPageData} canonical={canonicalPath} />
            {/* HERO */}
            <Hero
                {...pageData.hero}
                textSize="big"
                className="-news -full-width-copy"
            />

            {/* Page head */}
            <Container>
                <PageHead {...pageData.pageHeader} className="-news" />
            </Container>

            {/* Articles Section */}
            <Section className="-small-margin-bottom "></Section>
            <Section className="-small-margin-bottom">
                <Container>
                    <Articles
                        {...pageData.postsList}
                        temp="news"
                        pagination={{
                            currentPage,
                            totalPages,
                            skip,
                            limit,
                            archivePath,
                        }}
                    />
                </Container>
            </Section>

            <PageFooterSections pageData={pageData} hideFaq />
        </Layout>
    );
};

export default pageResources;
